import { ServicesManager } from '@ohif/core';
import classnames from 'classnames';
import React, { PropsWithChildren } from 'react';
import { usePredictions } from '../../../contexts/PredictionsContext';
import {
  PREDICTIONS_LOAD_FAILED_MESSAGE,
  usePredictionsLoadFailed,
} from '../../../contexts/predictions.hooks';
import { DetectionsList } from '../DetectionsList';
import { TogglePredictionsDisplayButton } from '../TogglePredictionsDisplayButton';
import { DetectionStatus } from './DetectionStatus';
import { ReviewProgress } from './ReviewProgress';
import { ToggleDetectionsStatusDisplayButton } from './ToggleDetectionsStatusDisplayButton';

export function CleaningPanelWrapper({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) {
  return (
    <div
      className={classnames(
        'flex flex-auto flex-col overflow-hidden text-white',
        className
      )}
      data-testid="cleaning-panel"
    >
      {children}
    </div>
  );
}

export function CleaningPanel({
  className,
  servicesManager,
}: {
  className?: string;
  servicesManager: ServicesManager;
}) {
  const { isLoading } = usePredictions();
  const loadFailed = usePredictionsLoadFailed();

  if (loadFailed) {
    return (
      <CleaningPanelWrapper
        className={classnames(
          'flex-grow flex-col justify-around text-primary-light',
          className
        )}
      >
        <h1>{PREDICTIONS_LOAD_FAILED_MESSAGE}</h1>
      </CleaningPanelWrapper>
    );
  }

  if (isLoading) {
    return (
      <CleaningPanelWrapper
        className={classnames(
          'flex-grow flex-col justify-around text-primary-light',
          className
        )}
      >
        <h1>Loading...</h1>
      </CleaningPanelWrapper>
    );
  }

  const isActivePanel = !className?.includes('hidden');

  return (
    <CleaningPanelWrapper className={className}>
      <TogglePredictionsDisplayButton />
      <ToggleDetectionsStatusDisplayButton />
      <ReviewProgress />
      <DetectionsList
        servicesManager={servicesManager}
        renderDetection={({ detection, index, prediction }) => (
          <DetectionStatus
            key={`${detection.annotationId}-${index}`}
            prediction={prediction}
            detection={detection}
            index={index}
            isDisplayed={isActivePanel}
          />
        )}
      />
    </CleaningPanelWrapper>
  );
}
